<template>
  <FormGroup>
    <FormField
      v-for="(value, key) in amenities"
      :key="key"
      :label="value"
      direction="row"
      :error="form.fieldErrors(key)"
    >
      <CheckmarkCrossmark v-model="form.fields[key]" />
    </FormField>
  </FormGroup>
</template>

<script setup lang="ts">
import { CheckmarkCrossmark, FormField, FormGroup, useForm } from '@tallo/design-system';
import { amenityNamesMap, Amenity } from '@tallo/property';

import { SaveAmenitiesDto } from '../../dtos/save-amenities.dto.interface';
import { usePropertyStore } from '../../stores/property.store';

const propertyStore = usePropertyStore();
const form = useForm<SaveAmenitiesDto>({
  ...getItems(),
});

const amenities = Object.fromEntries(Object.entries(amenityNamesMap).sort((a, b) => a[1].localeCompare(b[1]))) as {
  [key in Amenity]: string;
};

function getItems(): { [key in Amenity]: boolean | null } {
  const amenities = new Map<Amenity, boolean | null>();

  Object.keys(amenityNamesMap).forEach((key) => {
    amenities.set(key as Amenity, propertyStore.property?.amenities?.[key as Amenity] ?? null);
  });

  return Object.fromEntries(amenities) as { [key in Amenity]: boolean | null };
}

async function save() {
  return await form.submit((fields) => propertyStore.saveAmenities(fields));
}

defineExpose({ save, form });
</script>
